import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';

import '../../scss/Footer.scss';

const URL_TO_SHARE = 'https://project.wnyc.org/nyc-primary-2017';
const TWEET = 'NYC Primary Election is Tuesday 9/12. Check out this voter guide by @WNYC, @CityLimitsNews and @GothamGazette:';

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer__icon">
          <a title="Remember to vote on Sept. 12!" href="assets/primary.ics">
            <i id="calendar-icon" className="calendar-icon"></i>
            <Isvg src="assets/images/icons/calendar.svg" className="calendar-icon" />
          </a>
        </div>
        <div className="footer__sub">
          <h3>
            <a title="Remember to vote on Sept. 12!" href="assets/primary.ics">
              Remember to vote on Sept. 12!
            </a>
          </h3>
        </div>
        <div className="footer__icon">
          <a href="" target="_blank" rel="noopener noreferrer" title="Find your Poll Site">
            <Isvg src="assets/images/icons/location.svg" className="location-icon" />
          </a>
        </div>
        <div className="footer__sub">
          <h3>
            <a href="https://nyc.pollsitelocator.com/" target="_blank" rel="noopener noreferrer" title="Find your Poll Site">
              Find your Poll Site
            </a>
          </h3>
        </div>
        <div className="footer__icon">
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${URL_TO_SHARE}`} title="Share on Facebook" target="_blank" rel="noopener noreferrer">
            <Isvg src="assets/images/icons/facebook.svg" className="facebook-icon" />
          </a>

          <a href={`https://twitter.com/intent/tweet?text=${TWEET}&url=${URL_TO_SHARE}`} title="Tweet" target="_blank" rel="noopener noreferrer">
            <Isvg src="assets/images/icons/twitter.svg" className="twitter-icon" />
          </a>
        </div>
        <div className="footer__sub">
          <h3>Share This Guide</h3>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/lib/Footer.js